export default __webpack_public_path__ + "static/media/discover.192f961f.svg";